export default "/images/vendor/flag-icon-css/flags/1x1/na.svg?27a5988ed15ca88d9ca7f68e975b2b1a";